<template>
  <div class="tab-content tab-quote"></div>
</template>

<script>
import Tab from './../Tab'
export default {
  name: 'TabQuote',
  mixins: [Tab]
}
</script>

<style scoped>

</style>
